import {connect} from 'react-redux';

import {isJobRunning} from '../../../../../../../src/helpers/jobHelpers';
import {ExportContactsCsvJobModel} from '../../../../../../../src/models/api/jobModel';
import {exportCardsAsyncAction} from '../../../../../../../src/store/data/cards/cardsActions';
import {getExportContactsCsvJobs} from '../../../../../../../src/store/data/jobs/jobsSelectors';
import {getHasContactsManagerExportContacts} from '../../../../../../../src/store/featureFlags/featureFlagsSelectors';
import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../../../../srcCommon/helpers/reselectHelpers';
import {ExportContactsPopover} from './exportContactsPopover';

/*
 * Selectors.
 */

function makeGetExportJobsInProgress() {
  return createSelector(
    [getExportContactsCsvJobs],
    (exportJobs): ReadonlyArray<ExportContactsCsvJobModel> => exportJobs.filter(isJobRunning),
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  hasContactsManagerExportContacts: getHasContactsManagerExportContacts,
  exportJobsInProgress: makeGetExportJobsInProgress(),
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  onExportCardsAsync: exportCardsAsyncAction,
}));

export const ExportContactsPopoverContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExportContactsPopover);
